export function ModelPreviewLighting() {
  return (
    <>
      <ambientLight intensity={3} />
      <pointLight position={[10, 10, 10]} />
    </>
  );
}
